<template>
  <div>
    <section class="is-fullheight is-bold">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column is-4 is-offset-4">
              <h1 class="title is-4">
                Register an Account
              </h1>
              <div class="box">
                <div class="field">
                  <label class="label">Name</label>
                  <p class="control">
                    <input class="input" type="text" v-model="user.name" placeholder="Full Name">
                  </p>
                </div>
                <div class="field">
                  <label class="label">Email</label>
                  <p class="control">
                    <input class="input" type="text" v-model="user.email" placeholder="jsmith@example.org">
                    <p v-if="emailMessage" class="help is-danger">{{emailMessage}}</p>
                  </p>
                </div>
                <hr>
                <div class="field">
                  <label class="label">Password</label>
                  <p class="control">
                    <input class="input" v-model="user.password" type="password" placeholder="Enter Password">
                    <p v-if="message" class="help is-danger">{{message}}</p>
                  </p>
                </div>
                <div class="field">
                  <label class="label">Confirm Password</label>
                  <p class="control">
                    <input class="input" v-model="user.passwordConfirm" @keyup.enter="register(user)" type="password" placeholder="Confirm Password">
                    <p v-if="message" class="help is-danger">{{message}}</p>
                  </p>
                </div>
                <hr>
                <p class="control">
                  <button @click="register(user)" class="button is-link">Register</button>
                  <router-link to="/">
                    <button class="button is-default">Cancel</button>
                  </router-link>
                </p>
              </div>
              <p class="has-text-centered">
                <router-link to="/login">Already Registered?</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>

    </section>
    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from '@/Footer'
  import tenant from '@/tenant'
  export default {
    name: 'Register',
    data: function () {
      return {
        user: {
          name: '',
          email: '',
          password: '',
          passwordConfirm: ''
        },
        message: null,
        emailMessage: null
      }
    },
    methods: {
      register(user) {
        if (this.validatePasswords(user)) {
          if (user.password === user.passwordConfirm) {
            tenant.app.auth().createUserWithEmailAndPassword(user.email, user.password).then(() => {
              this.$router.push('/welcome')
            }).catch((error) => {
              if (error) {
                if (error.message.toUpperCase().indexOf('EMAIL') > -1) {
                  this.emailMessage = error.message
                } else {
                  this.message = error.message
                }
              }
              console.log(error)
            })
          }
        }
      },
      validatePasswords(user) {
        this.message = null
        this.emailMessage = null

        if (!user.password || !user.passwordConfirm) {
          this.message = 'Please enter and confirm passwords'
          return false
        }
        if (user.password !== user.passwordConfirm) {
          this.message = 'Passwords do not match'
          return false
        }

        return true
      }
    },
    created: function () {
      console.log(this.$route)
      let name = this.$route.query['name']
      let email = this.$route.query['email']

      if (name) {
        this.user.name = name
      }
      if (email) {
        this.user.email = email
      }
    },
    components: {
      Footer
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/user/Register.vue?1c8d6282